import { useMemo, useState } from 'react';
import { InternalApiListSelectorGroup, InternalApiListSelectorOption } from '../../../api-internal';
import { ManualCustomListSelectorCode } from './ListGroups';
import { isFeatureEnabled, ORGANISATION_FEATURE } from '../../../organisation/feature/helper';
import { useMe } from '../../../organisation/useMe';
import { DJ_REFERENCE_GROUP } from './useSelectorOptions';

interface Props {
  apiScreeningSelectorGroups: InternalApiListSelectorGroup[];
  type: ManualCustomListSelectorCode;
  apiSelectorOptions: InternalApiListSelectorOption[];
}

export const useSelectorGroups = ({ apiScreeningSelectorGroups, type, apiSelectorOptions }: Props) => {
  const [editedGroup, setEditedGroup] = useState<InternalApiListSelectorGroup>();
  const isGroupEdited = !!editedGroup;

  const { features } = useMe();
  const areReferenceGroupsHidden = !isFeatureEnabled(ORGANISATION_FEATURE.LIST_GROUPS_WITH_REFERENCE_GROUPS, features);

  let groups = useMemo(() => {
    const selectorGroups = apiScreeningSelectorGroups.toSorted((a, b) => a.name.localeCompare(b.name));

    if (type === ManualCustomListSelectorCode.DJ_SANCTION_LISTS) {
      // DJ PERSON/ENTITY Reference Code workaround
      const djPersonOptionValues = apiSelectorOptions
        .filter((option) => option.parentValue[0]?.startsWith('PERSON.'))
        .map((option) => option.value);
      return selectorGroups.map((group) => {
        return {
          ...group,
          code: group.code || '',
          enabledSelectorOptions: group.enabledSelectorOptions.filter((option) =>
            djPersonOptionValues.includes(option)
          ),
          subscribedSelectorOptions: group.subscribedSelectorOptions
            .filter((option) => djPersonOptionValues.includes(option))
            .filter((option) => (areReferenceGroupsHidden ? !option.includes(DJ_REFERENCE_GROUP) : true)),
        };
      });
    } else {
      return selectorGroups;
    }
  }, [apiScreeningSelectorGroups, type, apiSelectorOptions]);
  if (isGroupEdited && !editedGroup.code) {
    groups = [...groups, editedGroup];
  }

  const firstGroup = groups[0];

  return {
    groups,
    firstGroup,
    editedGroup,
    setEditedGroup,
    isGroupEdited,
  };
};
